<template>
  <IQOS :boxClass="'container-box mt-0'" :hideTitle="true">
      <h4 class="c-white">
          {{ $t('settings_cafe.online_menu.title')}}
      </h4>
      <a class="iqos-group-item d-block" :href="onlineMenuLink">
          {{onlineMenuLink}}
      </a>
      <p class="comment c-grey">
          {{ $t('settings_cafe.online_menu.description') }}
      </p>
      <p class="comment demo-warning" v-if="isDemoPeriod">
          {{ $t('settings_cafe.demo_warning') }}    
        </p>
  </IQOS>
</template>

<script>
import IQOS from '@/components/IQOS.vue'

export default {
    components: {
        IQOS
    },
    computed: {
        onlineMenuLink() {
            return this.$store.getters.onlineMenuLink("delivery");
        },
        isDemoPeriod() {
            return this.$store.getters['subscriptions/isDemoPeriod']();
        }
    }
}
</script>

<style>
a {
    font-size:2vh
}

.demo-warning {
  color: #FF6F00 !important;
}
</style>